var Backbone = require('backbone');

module.exports = Backbone.Model.extend({

    defaults: {
        name: 'Unknown',
        firstname: 'Unknown',
        lastname: 'Unknown',
        count: 0,
        percent: 0,
        eliminated: null,
        image: '/img/contestants/avatar.png',
        number: null,
        selected: false,
        imgLoaded: false,
        secondaryinfo: ''
    },

    initialize: function() {
        this.on('change:selected', this.isSelected, this);
    },
    /**
   *
   */
    isSelected: function(model, value, options) {
        console.log('isSelected', model, value, options);
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/standard-vote/app/scripts/models/vote-option.js
// module id = 280
// module chunks = 0